// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"155":"7d950d09","390":"66946a9f","565":"98642774","641":"343db817","785":"ca632079"}[chunkId] + ".css";
};